import type { ReactElement } from 'react';

import { LegalPage } from '~/components/pages/LegalPage';

function Page(): ReactElement {
  return <LegalPage pageKey="privacy" />;
}

export { Page };
